import styles from './../right-drawer.module.scss';
import { InvoicesPeriodTable, InvoicesPeriodDetailsTable } from '@flexo/atoms';
import { RIGHT_DRAWER, store } from '@flexo/reducers';
import { Button } from '@flexo/atoms';
import { useTranslation } from 'react-i18next';

export interface PaymentsListDrawerContentProps {
  type: 'overview' | 'details';
  drawerConfig: any;
}

export default function PaymentsListDrawerContent({ drawerConfig, type }: PaymentsListDrawerContentProps) {

  const dispatch = store.dispatch;
  const { t } = useTranslation();

  return (
    <div className={styles.Drawer__Content_Payments__List}>
      {type === 'overview' && <InvoicesPeriodTable data={drawerConfig.data} />}
      {type === 'details' && <InvoicesPeriodDetailsTable data={drawerConfig} />}
      {type === 'details' && <Button
        variant="secondary"
        color="grey"
        className={'mt-auto mb-1'}
        style={{
          maxWidth: 80,
          marginTop: 32,
        }}
        onClick={() => {
          dispatch(RIGHT_DRAWER.SetDrawer({
            type: 'COMMUNITY_PAYMENTS_LIST',
            drawerConfig: drawerConfig?.oldData || {}
          } as any))
        }}
        label={ t('widgets.tables.utils.back') as any }
      />
      }      
    </div>
      
  );
}